module.exports = __webpack_public_path__ + "img/9-1.fe40412d.png";